export default class EventLog {
    public id: number;
    public message: any;
    public authorId: number;
    public featureId: number;
    public corporationId: number;
    public createdAt: string;

    public ticket: any = null;
    public booking: any = null;

    constructor(
        id: number,
        message: string,
        authorId: number,
        featureId: number,
        corporationId: number,
        createdAt: string,
    ) {
        this.id = id;
        this.message = JSON.parse(message);
        this.authorId = authorId;
        this.featureId = featureId;
        this.corporationId = corporationId;
        this.createdAt = createdAt;
    }

    get logIcon(): string {
        if (['CONVERSATION_CLOSED', 'CONVERSATION_CONVERTED_TO_TICKET'].includes(this.message.type)) {
            return 'fa-info-circle';
        }

        if (this.ticket) {
            switch (this.ticket.type) {
                case 'defects-and-issues':
                    return 'fa-toolbox';
                case 'feedback':
                    return 'fa-megaphone';
                case 'questions':
                    return 'fa-question-circle';
            }
        }

        if (this.message.type === 'BOOKING_CANCELED') {
            return 'fa-calendar-times';
        }
    }

    get iconWrapperClasses(): string {
        if (['CONVERSATION_CLOSED', 'CONVERSATION_CONVERTED_TO_TICKET'].includes(this.message.type)) {
            return 'conversation-log';
        }

        if (this.ticket) {
            switch (this.ticket.type) {
                case 'defects-and-issues':
                    return 'log-purple';
                case 'feedback':
                    return 'log-green';
                case 'questions':
                    return 'log-blue';
            }
        }

        if (this.message.type === 'BOOKING_CANCELED') {
            return 'booking-canceled';
        }
    }

    get isMessageEvent(): boolean {
        return ['MESSAGE_NEW', 'TICKET_MESSAGE', 'MESSAGE_REPLY', 'TICKET_MESSAGE_REPLY'].includes(this.message.type);
    }

    public setTicket(ticket: any) {
        this.ticket = ticket;
    }

    public setBooking(booking: any) {
        this.booking = booking;
    }
}
